export default __webpack_public_path__ + "static/media/sqsycg.305a6a76.png";